import { useEffect, useState } from 'react';
import { LandingPageThemeId } from '@client/new/common/landingPageThemes';
import { PageLookEditor, requestedTheme } from './pageLook';

type BuilderLocation = { query?: Record<string, unknown> };

// Read ?theme= once and drop it from the URL, so a reload or bookmark does not preselect it over a theme saved since.
export const useRequestedTheme = (
  router: { replace: (location: BuilderLocation) => void },
  location: BuilderLocation | undefined,
  editor: PageLookEditor | null,
): LandingPageThemeId | null => {
  const [requested] = useState(() =>
    editor ? requestedTheme(location?.query?.theme) : null,
  );

  useEffect(() => {
    if (!location?.query || !('theme' in location.query)) return;
    const { theme: _theme, ...query } = location.query;
    router.replace({ ...location, query });
  }, [router, location]);

  return requested;
};
